export * from './FormItem';
try {
    // @ts-ignore
    FormItem.displayName = "FormItem";
    // @ts-ignore
    FormItem.__docgenInfo = { "description": "", "displayName": "FormItem", "props": { "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/index.tsx#FormItem"] = { docgenInfo: FormItem.__docgenInfo, name: "FormItem", path: "src/components/FormItem/index.tsx#FormItem" };
}
catch (__react_docgen_typescript_loader_error) { }